<form [formGroup]="addressForm">
  <div class="row">
    <!-- Address Line 1 -->
    @if (getFieldConfig('addressLine1')?.visible) {
      <div class="col-12 mb-3">
        <label class="form-label">
          Address Line 1
          @if (getFieldConfig('addressLine1')?.required) {
            <span class="text-danger">*</span>
          }
        </label>
        <textarea
          formControlName="addressLine1"
          [placeholder]="'Enter address line 1'"
          class="form-control"
          [disabled]="disabled"
          (blur)="onFieldTouched()"
          rows="3"
        ></textarea>
        @if (submitted() && getFieldConfig('addressLine1')?.required && !addressForm.controls['addressLine1'].value) {
          <div class="text-danger">
            <span>Address Line 1 is required</span>
          </div>
        }
      </div>
    }
    <!-- Address Line 2 -->
    @if (getFieldConfig('addressLine2')?.visible) {
      <div class="col-12 mb-3">
        <input-field
          [label]="'Address Line 2'"
          [type]="'text'"
          [placeholder]="'Enter address line 2'"
          formControlName="addressLine2"
          [required]="getFieldConfig('addressLine2')?.required || false"
          [disabled]="disabled"
          [errormessage]="getFieldConfig('addressLine2')?.required ? 'Address Line 2 is required' : ''"
          (blur)="onFieldTouched()"
        ></input-field>
        @if (submitted() && getFieldConfig('addressLine2')?.required && !addressForm.controls['addressLine2'].value) {
          <div class="text-danger">
            <span>Address Line 2 is required</span>
          </div>
        }
      </div>
    }

    <!-- City -->
    @if (getFieldConfig('cityId')?.visible) {
      <div class="col-12 mb-3">
        <generic-dropdown
          [items]="cities$ | async"
          [label]="'City'"
          [allowSearch]="true"
          [clearable]="true"
          [placeholder]="'Select city'"
          formControlName="cityId"
          [required]="getFieldConfig('cityId')?.required || false"
          [multiselect]="false"
          [disabled]="disabled"
          [errormessage]="getFieldConfig('cityId')?.required ? 'City is required' : ''"
          (blur)="onFieldTouched()"
        >
        </generic-dropdown>
        @if (submitted() && getFieldConfig('cityId')?.required && addressForm.get('cityId')?.invalid) {
          <div class="text-danger">
            <span>City is required</span>
          </div>
        }
      </div>
    }

    <!-- Suite -->
    @if (getFieldConfig('suite')?.visible) {
      <div class="col-md-6 mb-3">
        <input-field
          [label]="'Suite'"
          [type]="'text'"
          [placeholder]="'Enter suite'"
          formControlName="suite"
          [required]="getFieldConfig('suite')?.required || false"
          [disabled]="disabled"
          [errormessage]="getFieldConfig('suite')?.required ? 'Suite is required' : ''"
          (blur)="onFieldTouched()"
        ></input-field>
        @if (submitted() && getFieldConfig('suite')?.required && !addressForm.controls['suite'].value) {
          <div class="text-danger">
            <span>Suite is required</span>
          </div>
        }
      </div>
    }
    <!-- Postal Code -->
    @if (getFieldConfig('postalCode')?.visible) {
      <div class="col-md-6 mb-3">
        <input-field
          [label]="'Postal Code'"
          [type]="'text'"
          [placeholder]="'Enter postal code'"
          formControlName="postalCode"
          [required]="getFieldConfig('postalCode')?.required || false"
          [disabled]="disabled"
          [errormessage]="getFieldConfig('postalCode')?.required ? 'Postal Code is required' : ''"
          (blur)="onFieldTouched()"
        ></input-field>
        @if (submitted() && getFieldConfig('postalCode')?.required && !addressForm.controls['postalCode'].value) {
          <div class="text-danger">
            <span>Postal Code is required</span>
          </div>
        }
      </div>
    }

    @if (getFieldConfig('addressType')?.visible) {
      <div class="col-12 mb-3">
        <generic-dropdown
          [items]="addressTypes"
          [label]="'Address Type'"
          [allowSearch]="true"
          [clearable]="false"
          [placeholder]="'Select address type'"
          formControlName="addressType"
          [required]="getFieldConfig('addressType')?.required || false"
          [multiselect]="false"
          [disabled]="disabled"
          [errormessage]="getFieldConfig('addressType')?.required ? 'Address Type is required' : ''"
          (blur)="onFieldTouched()"
        >
        </generic-dropdown>
        @if (submitted() && getFieldConfig('addressType')?.required && addressForm.get('addressType')?.invalid) {
          <div class="text-danger">
            <span>Address Type is required</span>
          </div>
        }
      </div>
    }
  </div>
</form>
